import { createReducer } from "@reduxjs/toolkit";
import type { RetrievalState } from "@redux/state/shared-types";
import { retrieveEducationalAdvisors } from "./retrieve-educational-advisors";
import type { EducationalAdvisorListVM } from "@shared-kernel/application/ports/educational-advisor/educational-advisor-repository";

const initialState: RetrievalState<EducationalAdvisorListVM> = { data: { teachers: [], providers: [] }, fetching: "idle" };

export const retrieveEducationalAdvisorsReducer = createReducer<RetrievalState<EducationalAdvisorListVM>>(initialState, builder => {
  builder.addCase(retrieveEducationalAdvisors.fulfilled, (state, { payload }) => {
    return {
      ...state,
      data: payload,
      fetching: "success",
    };
  });
  builder.addCase(retrieveEducationalAdvisors.pending, state => {
    return {
      ...state,
      fetching: "pending",
    };
  });
  builder.addCase(retrieveEducationalAdvisors.rejected, state => {
    return {
      ...state,
      fetching: "failed",
    };
  });
});
